export default function TrustSection() {
  return (
    <section className="w-full px-4 md:px-8 py-16 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-12 items-center">
          <div className="lg:w-2/5 w-full">
            <div className="aspect-[3/4] rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Casual%20stylish%20young%20adult%20smiling%20while%20browsing%20smartphone%20outdoors%20against%20soft%20blue%20sky%20background%2C%20natural%20daylight%20portrait%2C%20lifestyle%20fashion%20photography%2C%20optimistic%20fresh%20mood%2C%20no%20text%2C%20no%20branding&width=600&height=800&seq=trust-v2-img&orientation=portrait"
                alt="Satisfied AllChinaBuy Spreadsheet user"
                title="Why Buyers Trust Our AllChinaBuy Spreadsheet"
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>
          </div>

          <div className="lg:w-3/5 w-full">
            <span className="inline-flex items-center gap-1.5 text-xs font-semibold text-foreground-500 uppercase tracking-wide">
              <i className="ri-double-quotes-l w-4 h-4 flex items-center justify-center"></i>
              Buyer Review
            </span>
            <h2 className="mt-4 text-2xl md:text-4xl font-extrabold text-foreground-950 leading-tight">
              Why Buyers Trust Our
              <br />
              <span className="text-foreground-500">AllChinaBuy Spreadsheet</span>
            </h2>
            <blockquote className="mt-8 text-base md:text-lg text-foreground-700 leading-relaxed italic">
              &ldquo;I have been using various spreadsheets for AllChinaBuy over the past two years, and
              this one is by far the most organized and reliable. The <strong>allchinabuy spreadsheet</strong>
              helped me discover sellers I would never have found on my own, and the comparison tables made
              it easy to find the best prices. I have saved at least 30% on my orders since switching to
              this <strong>allchinabuy sheet</strong>. Highly recommended for anyone who shops on AllChinaBuy
              regularly.&rdquo;
            </blockquote>
            <p className="mt-6 text-sm font-bold text-foreground-900">
              — Verified Buyer, United States
            </p>

            <div className="mt-8 grid grid-cols-3 gap-4 text-center">
              <div className="bg-background-50 rounded-lg p-4 border border-background-200/70">
                <p className="text-2xl md:text-3xl font-extrabold text-primary-500">10K+</p>
                <p className="text-xs text-foreground-600 mt-1">Products Listed</p>
              </div>
              <div className="bg-background-50 rounded-lg p-4 border border-background-200/70">
                <p className="text-2xl md:text-3xl font-extrabold text-accent-500">14</p>
                <p className="text-xs text-foreground-600 mt-1">Categories</p>
              </div>
              <div className="bg-background-50 rounded-lg p-4 border border-background-200/70">
                <p className="text-2xl md:text-3xl font-extrabold text-secondary-500">Daily</p>
                <p className="text-xs text-foreground-600 mt-1">Updates</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}